import { render, staticRenderFns } from "./ProductOptionsList.vue?vue&type=template&id=3045fe7e&scoped=true&"
import script from "./ProductOptionsList.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045fe7e",
  null
  
)

export default component.exports